var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgInviteNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 39,
    viewBox: "0 0 44 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.0945 20.7258C28.5891 21.7721 29.6364 23.1896 29.6364 25.0796V28.4546H34V25.0796C34 22.6271 30.1055 21.1758 27.0945 20.7258ZM25.2727 19.4546C27.6836 19.4546 29.6364 17.4408 29.6364 14.9546C29.6364 12.4683 27.6836 10.4546 25.2727 10.4546C24.76 10.4546 24.28 10.5671 23.8218 10.7246C24.7606 11.9218 25.2727 13.4149 25.2727 14.9546C25.2727 16.4943 24.7606 17.9873 23.8218 19.1846C24.28 19.3421 24.76 19.4546 25.2727 19.4546ZM18.7273 19.4546C21.1382 19.4546 23.0909 17.4408 23.0909 14.9546C23.0909 12.4683 21.1382 10.4546 18.7273 10.4546C16.3164 10.4546 14.3636 12.4683 14.3636 14.9546C14.3636 17.4408 16.3164 19.4546 18.7273 19.4546ZM18.7273 12.7046C19.9273 12.7046 20.9091 13.7171 20.9091 14.9546C20.9091 16.1921 19.9273 17.2046 18.7273 17.2046C17.5273 17.2046 16.5455 16.1921 16.5455 14.9546C16.5455 13.7171 17.5273 12.7046 18.7273 12.7046ZM18.7273 20.5796C15.8145 20.5796 10 22.0871 10 25.0796V28.4546H27.4545V25.0796C27.4545 22.0871 21.64 20.5796 18.7273 20.5796ZM25.2727 26.2046H12.1818V25.0908C12.4 24.2808 15.7818 22.8296 18.7273 22.8296C21.6727 22.8296 25.0545 24.2808 25.2727 25.0796V26.2046Z",
    fill: "#909090"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInviteNew);
export default __webpack_public_path__ + "static/media/invite-new.64075add414d067a118f3a0901ca7cfa.svg";
export { ForwardRef as ReactComponent };